<div>
    <app-icon ic="IcCopy" size="s" color="var(--color-primary-60)" (click)="copyBtnAction()"></app-icon>
</div>
